/* tslint:disable:max-line-length */
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  providerDoesNotExist: {
    defaultMessage:
      'There was a temporary problem connecting to your bank. Please select your bank again to complete the payment.',
    id: 'ChooseProvider.providerDoesNotExist',
  },
});
